<template>
  <div class="bg-gray-100 px-4 pt-16 lg:px-16 h-full">
    <div class="flex items-center justify-between">
      <h1 class="text-4xl font-poppins font-normal">Notifications</h1>
      <button class="font-poppins text-blue-500 cursor-pointer" @click.prevent="markAllAsRead()">Mark all as read</button>
    </div>
    
    <section class="my-10">
      <StackedList :items="notifications.notifications">
        <template #left="{ item }">
          <component
            :is="getIcon(item.type).name"
            class="inline-block w-6 h-6 mr-12"
            :class="getIcon(item.type).color"
          />
          <span class="text-sm font-poppins" v-if="item.invoice ">
            <router-link :to="`/invoices/${item.invoiceId}`">
              <span class="underline font-bold">{{item.invoice &&  item.invoice.invoiceNumber }}
              </span>
            </router-link>
            <span>{{" - " + item.message}}</span>
          </span>
          <span v-else>
            <span>{{ item.message}}</span>
          </span>
        </template>
        <template #center="{ item }">
          <span class="text-sm text-gray-500 italic font-poppins mr-12">{{
            calculateTimeAgo(item.createdAt)
          }}</span>
          <span class="text-blue-500 font-poppins cursor-pointer" v-if="!item.read" @click="markAsRead(item.id)">Mark as read</span>
        </template>
        <template #right="{ item }">
          <router-link :to="`/invoices/${item.invoiceId}`"
          ><chevron-right-icon class="text-gray-500" />
          </router-link>
        </template>
      </StackedList>
    </section>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import StackedList from '@/components/lists/StackedList.vue';
import { useIcon } from '@/helpers/composables';
import { onMounted } from 'vue';
import { useToast } from '@/helpers/composables';
import { useState } from '@/helpers/composables';
import moment from 'moment';

export default {
  components: {
    StackedList,
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    const [notifications, setNotifications] = useState([]);
    
    onMounted(() => {
      store.dispatch('notifications/getNotifications');
      setNotifications(store.state.notifications);
    });

    function getIcon(type) {
      const icon = useIcon(type);
      return icon.value;
    }

    async function markAsRead(notificationId) {
      try {
          const { message } = await store.dispatch(
            'patch',
            { action: `/notifications/${notificationId}`},
          );
          toast.show(message);
          store.dispatch('notifications/getNotifications');
          setNotifications(store.state.notifications);
      }
      catch(err) {
        console.log(err);
      }
    }

     async function markAllAsRead() {
      try {
        const { message } = await store.dispatch(
          'post',
          { action: `/notifications/read`},
        );
        toast.show(message);
        store.dispatch('notifications/getNotifications');
        setNotifications(store.state.notifications);
      }
      catch(err) {
        console.log(err);
      }
    }

    function calculateTimeAgo(date) {
      const currentDate= moment();
      const createdDate = moment(date);
      if(currentDate.diff(createdDate,'days') > 0){
        return currentDate.diff(createdDate,'days') + ' days';
      }
      else {
        if(currentDate.diff(createdDate,'hours') > 0) {
          return currentDate.diff(createdDate,'hours') + ' hours';
        }
        else {
          if(currentDate.diff(createdDate,'minutes') > 0){
            return currentDate.diff(createdDate,'minutes') + ' minutes';
          }
          else {
            return currentDate.diff(createdDate,'seconds') + ' seconds';
          }
        }
      }
    }
    return {
      notifications,
      getIcon,
      markAsRead,
      calculateTimeAgo,
      markAllAsRead
    };
  },
};
</script>
